import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';

import {ReportsRoutingModule} from './reports.routing.module';
import {NgApexchartsModule} from 'ng-apexcharts';
import {TicketsReportsComponent} from './tickets-reports/tickets-reports.component';
import {ReportsCrmComponent} from './reports-crm.component';
import {AngularMyDatePickerModule} from 'angular-mydatepicker';
import {ReactiveFormsModule} from '@angular/forms';


@NgModule({
    declarations: [ReportsCrmComponent, TicketsReportsComponent],
    imports: [
        CommonModule,
        HttpClientModule,
        ReportsRoutingModule,
        NgApexchartsModule,
        AngularMyDatePickerModule,
        ReactiveFormsModule
    ]

})
export class ReportsModule {
}
